import { useState, useEffect } from "react";
import { ScreeningSettings } from "./components/ScreeningSettings";
import { Layout } from "providers/Layout";
import { useVerificationTemplatesController } from "./controller";
import { Pagination } from "shared/components/Pagination";
import { Template } from "types/landlord/verificationTemplate";
import { useAuthContext } from "providers/Auth";
import { Redirect } from "shared/components/Redirect";
import { ScreeningTemplatesHeader } from "shared/app/ScreeningTemplatesHeader";

export const VerificationTemplatesView = () => {
  const {
    defaultTemplate,
    verificationSchemas,
    templatesData,
    setCurrentPage,
    isLoading
  } = useVerificationTemplatesController();

  const [templates, setTemplates] = useState<Template[]>([]);

  const addTemplate = (newTemplate) => {
    setTemplates((currentTemplates) => [...currentTemplates, newTemplate]);
  };

  const removeTemplateById = (templateId) => {
    setTemplates((currentTemplates) =>
      currentTemplates.filter((template) => template.id !== templateId)
    );
  };

  useEffect(() => {
    if (templatesData?.items) setTemplates(templatesData.items);
  }, [templatesData?.items]);

  const { type, auth, permissions } = useAuthContext();

  if (!type.isBoomScreen) return <Redirect href="/" />;
  if (type.isPropertyManager && !auth?.can_access_screening_templates)
    return (
      <Redirect href={permissions.canManageDiscounts ? "/discounts" : "/"} />
    );

  return (
    <Layout
      headerClassName="pb-0 border-b border-alpha-40 pt-6"
      header={<ScreeningTemplatesHeader />}
    >
      <div className="mx-auto flex flex-wrap">
        <div className="flex w-full gap-x-4">
          {defaultTemplate && (
            <ScreeningSettings
              templates={templates}
              isLoading={isLoading}
              verificationSchemas={verificationSchemas || []}
              defaultTemplate={defaultTemplate}
              addTemplate={addTemplate}
              removeTemplateById={removeTemplateById}
            />
          )}
        </div>
        <div className="ml-auto mt-4">
          <Pagination
            total={Number(templatesData?.page_count)}
            current={Number(templatesData?.current_page)}
            onChange={(p) => setCurrentPage(p)}
          />
        </div>
      </div>
    </Layout>
  );
};
